import {signalStore, withComputed, withMethods, withProps} from '@ngrx/signals';
import {Asset} from 'src/app/infrastructure/moovement-api/models/asset';
import {computed, inject} from '@angular/core';
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {GatewayStore} from 'src/app/domain/devices/gateway/gateway.store';
import {WaterPointsStore} from 'src/app/domain/assets/water-points/water-points.store';

export const AssetsStore = signalStore(
  { providedIn: 'root' },
  withProps(() => ({
    animalsStore: inject(AnimalsStore),
    fixedSamplePointsStore: inject(FixedSamplePointsStore),
    gatewayStore: inject(GatewayStore),
    waterPointsStore: inject(WaterPointsStore)
  })),
  withComputed(({ animalsStore, fixedSamplePointsStore, gatewayStore, waterPointsStore }) => ({
    loading: computed(() => {
      return animalsStore.loading() || fixedSamplePointsStore.loading() || gatewayStore.loading() || waterPointsStore.loading();
    }),
    assets: computed(() => {
      const result: Asset[] = [];
      result.push(...animalsStore.entities());
      result.push(...fixedSamplePointsStore.entities());
      result.push(...gatewayStore.entities());
      result.push(...waterPointsStore.entities());
      return result;
    })
  })),
  withMethods(({ animalsStore, fixedSamplePointsStore, gatewayStore, waterPointsStore }) => ({
    assetIdToUrl: (id: string) => {
      if (animalsStore.entityMap()[id]) return '/main/animal-details';
      if (fixedSamplePointsStore.precipitationSamplePointsById().get(id)) return '/main/precipitation-sample-point-details';
      if (fixedSamplePointsStore.proximitySamplePointsById().get(id)) return '/main/proximity-sample-point-details';
      if (gatewayStore.entityMap()[id]) return '/main/gateway-details';
      if (waterPointsStore.entityMap()[id]) return '/main/water-point-details';

      return '/main/information-center';
    }
  })),
  withComputed(({ assets }) => ({
    assetsById: computed(() => {
      const result = new Map<string, Asset>();
      assets().forEach(asset => {
        result.set(asset.id, asset);
      });

      return result;
    })
  }))
);
